import { useEffect, useState } from 'react';

export function useDebounce<T>(newValue: T, waitMs: number = 250): T {
  const [storedValue, setStoredValue] = useState(newValue);

  useEffect(() => {
    const timeout = setTimeout(() => {
      // Use function form to support cases where T is a function
      setStoredValue(() => newValue);
    }, waitMs);

    return () => {
      clearTimeout(timeout);
    };
  }, [newValue, waitMs]);

  return storedValue;
}

export default useDebounce;
